<template>
	<div>
		<div v-for="list in mailingListData" :key="list.id" class="uk-grid-small uk-grid-collapse uk-align-center" uk-grid>
			<div class="uk-width-expand uk-text-meta uk-margin-small-bottom">{{ list.name }}</div>
			<div class="uk-width-auto">
				<label class="switch">
					<input type="checkbox" :id="'list-' + list.id" :checked="list.subscribed" @change="toggleSubscription(list, $event.target.checked)" :disabled="loading">
					<span class="slider round"></span>
				</label>
			</div>
		</div>
		<loading-indicator v-if="loading" />
		<div v-if="success" class="success-message uk-margin-top uk-alert uk-alert-success">{{ message }}</div>
		<div v-if="error" class="error-message uk-alert-danger uk-alert">{{ message }}</div>
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },	
	props: {
		mailingListData: {
			type: Array,
			required: true
		},
		siteId: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			error: null,
			success: false,
			loading: false,
			message: null
		};
	},
	computed: {
		csrfName() {
			return window.csrfTokenName;
		},
		csrfToken() {
			return window.csrfTokenValue;
		}
	},
	methods: {
		toggleSubscription(list, subscribed) {
			
			this.loading = true;
			this.error = null;
			this.success = false;
			this.message = null;

			let url, formData = new FormData();
			formData.append(this.csrfName, this.csrfToken);

			if (subscribed) {
				url = '/actions/campaign/contacts/subscribe-mailing-list';
				formData.append('contactId', list.contactId);
				formData.append('mailingListId', list.id);
			} else {
				url = '/actions/campaign/contacts/unsubscribe-mailing-list';
				formData.append('contactId', list.contactId);
				formData.append('mailingListId', list.id);
			}

			axios({
				method: 'post',
				url: url,
				data: formData,
				headers: {
					'Accept': 'application/json',
				}
			})
			.then(response => {
				this.success = true;
				this.message = `Aanmelding ${subscribed ? 'bevestigd' : 'geannuleerd'}`;
				this.$logger(response);
			})
			.catch(error => {
				this.error = true;
				this.message = 'Er is een fout opgetreden tijdens het aan of afmelden.';
				this.$logger(error, 'error');
			})
			.finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>

<style>
/* The switch - the box around the slider */
.switch {
	position: relative;
	display: inline-block;
	width: 56px;
	height: 30px;
}

/* Hide default HTML checkbox */
.switch input {
	opacity: 0;
	width: 0;
	height: 0;
}

/* The slider */
.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc;
	-webkit-transition: .4s;
	transition: .4s;
}

.slider:before {
	position: absolute;
	content: "";
	height: 26px;
	width: 26px;
	left: 2px;
	bottom: 2px;
	background-color: white;
	-webkit-transition: .4s;
	transition: .4s;
}

input:checked + .slider {
	background-color: #2196F3;
}

input:focus + .slider {
	box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}
</style>
